/*
 * @Author: your name
 * @Date: 2021-12-15 17:07:58
 * @LastEditTime: 2021-12-21 16:50:38
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\components\header.js
 */
import React from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
export default function Header() {
  let swt = () => {
    let myhref = window.location.href;
    let swtlj =
      "http://plt.zoosnet.net/LR/Chatpre.aspx?id=PLT65467523&lng=cn&r=" +
      encodeURIComponent(document.referrer) +
      "&p=" +
      encodeURIComponent(myhref);
    window.open(swtlj, "_blank");
  };
  let earList = [
    { class: "xm", ref: "/product" },
    { class: "logo", ref: "/home" },
    { class: "chat", ref: "/" },
  ];
  let headerList = [
    { class: "tsxm", ref: "/product", title: "特色项目" },
    { class: "aljh", ref: "/home", title: "案例集合" },
    { class: "zjtd", ref: "/unit", title: "技术团队" },
    { class: "ppjs", ref: "/projectMap", title: "品牌介绍" },
    { class: "lxwm", ref: "/linkMap", title: "联系我们" },
  ];
  let tem = null;
  let path = useLocation().pathname;
  let linkClick = (e) => {
    if (e.target.pathname === "/") {
      swt();
    }
  };

  if (path !== "/home" && path !== "/" && path) {
    tem = (
      <div className="basepage">
        {headerList.map((v, index) => (
          <div key={index} className={v.class}>
            <NavLink
              to={v.ref}
              style={({ isActive }) => {
                return {
                  color: path === v.ref ? "#BF9B61" : "",
                  borderBottom: path === v.ref ? "1px solid #BF9B61" : "",
                  fontWeight: path === v.ref ? "bold" : "",
                };
              }}
            >
              {v.title}
            </NavLink>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div>
      <div className="header">
        {earList.map((ear, index) => (
          <Link
            className={[ear.class]}
            key={index}
            to={{ pathname: ear.ref }}
            onClick={linkClick}
          ></Link>
        ))}
      </div>
      {tem}

      <div className="left_box">
        <a onClick={swt} target="_blank" rel="noreferrer">
          <img
            src="http://www.isbelle.com/templets/2018/wap/images/index/right_zx.png"
            width="100%"
            height="100%"
          />
        </a>
      </div>
    </div>
  );
}
